<template>
  <v-dialog v-model="show" width="600">
    <v-card class="mt-2">
      <v-card-title
        primary-title
        style="padding-left: 8px; padding-bottom: 8px"
      >
        <span class="headline mb-0">INV No の {{ title }}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          @keydown="(e) => handleTab(e)"
          tabindex="6"
          id="save"
          :disabled="!canSave || !valid"
          @click="save"
          small
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn
          @keydown="(e) => handleKeyDown(e)"
          tabindex="7"
          id="back"
          @click="back()"
          small
          >{{ $t("app.buttons.back") }}</v-btn
        >
      </v-card-actions>
      <v-form ref="form" lazy-validation v-model="valid" value>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                id="invNo"
                tabindex="1"
                :disabled="!hasUpdated"
                :rules="[
                  (v) =>
                    !v || v.length <= 20 || 'INV Noを20文字以下にしてください',
                ]"
                required
                label="INV No"
                clearable
                v-model.trim="invoice.invNo"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="secRefNo"
                tabindex="2"
                :rules="[
                  (v) =>
                    !v ||
                    v.length <= 20 ||
                    'SEC Ref Noを20文字以下にしてください',
                ]"
                required
                label="SEC Ref No"
                clearable
                v-model.trim="invoice.secRefNo"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="bkNo"
                tabindex="3"
                :rules="[
                  (v) =>
                    !v || v.length <= 20 || 'B/K Noを20文字以下にしてください',
                ]"
                label="B/K No"
                clearable
                v-model.trim="invoice.bkNo"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="siNo"
                tabindex="4"
                @keydown="(e) => checkIfEnter(e, 'appendSINo()')"
                required
                label="S/I No"
                clearable
                v-model.trim="siNo"
                append-outer-icon="add"
                @click:append-outer="appendSINo"
              />
              <div class="chip-wrap">
                <v-chip
                  tabindex="-1"
                  @input="closeSiNos(item)"
                  v-for="item in siNos"
                  :key="item"
                  class="ma-2"
                  close
                  color="orange"
                  outline
                >
                  {{ item }}
                </v-chip>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                id="edNo"
                tabindex="5"
                @keydown="(e) => checkIfEnter(e, 'appendEDNo()')"
                required
                label="E/D No"
                clearable
                v-model.trim="edNo"
                append-outer-icon="add"
                @click:append-outer="appendEDNo"
              />
              <div class="chip-wrap">
                <v-chip
                  tabindex="-1"
                  @input="closeEDNos(item)"
                  v-for="item in edNos"
                  :key="item"
                  class="ma-2"
                  close
                  color="orange"
                  outline
                >
                  {{ item }}
                </v-chip>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["isJp", "hasUpdated"],
  data() {
    return {
      type: "",
      edNo: "",
      edNos: [],
      siNo: "",
      siNos: [],
      invoice: {},
      show: false,
      valid: false,
      title: "",
      invNoRules: [
        (v) =>
          !!v || "invoice No " + this.$t("app.validator.messages.required"),
      ],
    };
  },
  methods: {
    popup() {
      this.title = "追加";
      this.type = "NEW";
      this.invoice = {};
      this.show = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    editInvoice(invoice) {
      this.title = "編集";
      this.show = true;
      this.invoice = invoice;
      if (invoice.edNo && invoice.edNo.trim() !== "") {
        this.edNos = invoice.edNo.split(" / ");
      }
      if (invoice.siNo && invoice.siNo.trim() !== "") {
        this.siNos = invoice.siNo.split(" / ");
      }
      this.type = "EDIT";
    },
    save() {
      if (this.siNos.length > 0) {
        this.$set(this.invoice, "siNo", this.siNos.join(" / "));
      } else {
        this.$set(this.invoice, "siNo", null);
      }
      if (this.edNos.length > 0) {
        this.$set(this.invoice, "edNo", this.edNos.join(" / "));
      } else {
        this.$set(this.invoice, "edNo", null);
      }
      if (this.type !== "EDIT") {
        this.invoice.attachments = [];
        this.resolve(this.invoice);
      }
      this.back();
    },
    back() {
      this.show = false;
      this.invoice = {};
      this.$forceUpdate();
      this.siNos = [];
      this.edNos = [];
      this.edNo = null;
      this.siNo = null;
    },
    appendSINo() {
      if (!this.siNo) {
        //this.$message('', 'S/I No can not empty.')
        return;
      }
      if (this.siNo.length > 20) {
        this.$message("", "siNoを20文字以下にしてください");
        return;
      }
      if (this.siNos.indexOf(this.siNo) !== -1) {
        this.$message("", "siNo重複");
        return;
      }
      this.siNos.push(this.siNo);
      this.siNo = null;
    },
    closeSiNos(item) {
      const index = this.siNos.indexOf(item);
      if (index > -1) {
        this.siNos.splice(index, 1);
      }
    },
    appendEDNo() {
      if (!this.edNo) {
        //this.$message('', 'E/D No can not empty.')
        return;
      }
      if (this.edNo.length > 20) {
        this.$message("", "edNoを20文字以下にしてください");
        return;
      }
      if (this.edNos.indexOf(this.edNo) !== -1) {
        this.$message("", "edNo重複");
        return;
      }
      this.edNos.push(this.edNo);
      this.edNo = null;
    },
    closeEDNos(item) {
      const index = this.edNos.indexOf(item);
      if (index > -1) {
        this.edNos.splice(index, 1);
      }
    },
    checkIfEnter(e, funcName) {
      console.log(e);
      if ("Enter" === e.key) {
        console.log("this." + funcName);
        eval("this." + funcName);
        // this.appendEDNo()
      }
      if ("appendEDNo()" === funcName && "Tab" === e.key) {
        this.handleTab(e);
      }
    },
    handleKeyDown(e) {
      if ("Tab" === e.key) {
        this.handleTab(e);
      }
    },
    handleTab(event) {
      var focusableElements = [];
      focusableElements.push(document.getElementById("invNo"));
      focusableElements.push(document.getElementById("secRefNo"));
      focusableElements.push(document.getElementById("bkNo"));
      focusableElements.push(document.getElementById("siNo"));
      focusableElements.push(document.getElementById("edNo"));
      focusableElements.push(document.getElementById("save"));
      focusableElements.push(document.getElementById("back"));
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.shiftKey) {
        // 如果按下了 shift + tab，则反向循环
        if (document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        }
      } else {
        // 如果只按下了 tab，则正向循环
        if (document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }
    },
  },
  computed: {
    canSave() {
      return this.siNos.length > 0;
    },
  },
};
</script>
